var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBibleNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "#FDDFCA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0226 27.9407L37.7439 25.07L67.1088 22.5009C67.6535 22.4533 68.1327 22.8554 68.1803 23.4L72.2932 70.4106C72.3309 70.8414 72.1738 71.2692 71.8663 71.5755L68.7389 74.6629L64.747 25.2719L30.0226 27.9407Z",
    fill: "#FBDDC8",
    stroke: "#F96B21",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M35.9183 26.1128L37.9396 25.437L67.3046 22.8679C67.8492 22.8203 68.3284 23.2224 68.376 23.767L72.4889 70.7777C72.5266 71.2084 71.9328 71.8341 71.6253 72.1404L67.4395 23.9537C67.4117 23.6369 67.1318 23.4019 66.8198 23.4292L35.9179 26.1078L35.9183 26.1128Z",
    fill: "#F96B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3685 27.9005L63.6349 24.9901C64.5707 24.9082 65.3998 25.604 65.4817 26.5398L69.5483 73.0207C69.6332 73.9911 68.9153 74.8521 67.9399 74.9375L34.7378 77.8423C33.7674 77.9272 32.9064 77.2092 32.821 76.2339L28.7597 29.8124C28.6748 28.842 29.3927 27.9809 30.3681 27.8956L30.3685 27.9005Z",
    fill: "#FFDFCA",
    stroke: "#F96B21",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M39.9356 66.3767C33.8533 58.4425 39.2638 47.8066 37.9684 37.8471C37.3167 32.8503 35.2826 29.6158 33.413 27.6341L31.3484 27.8147C29.8333 27.9473 28.6917 29.04 28.7978 30.253L32.7829 75.8031C32.889 77.0161 34.2031 77.8939 35.7181 77.7614L66.8705 75.0359C66.8705 75.0359 46.0183 74.3158 39.9311 66.3821L39.9356 66.3767Z",
    fill: "#F96B21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1912_13636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7214 90.7324L54.3215 87.8713L51.6241 90.2865L52.1914 83.8018L57.2887 84.2477L56.7214 90.7324Z",
    fill: "#FDDFCA",
    stroke: "#FB6B21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7718 31.3197L53.3106 28.2173C52.2718 28.1264 51.3534 28.9249 51.2593 30.0007L46.7678 81.3386C46.6737 82.4144 47.4395 83.3602 48.4783 83.4511L83.9395 86.5536C84.9783 86.6444 85.8967 85.846 85.9908 84.7702L90.4823 33.4322C90.5764 32.3564 89.8106 31.4106 88.7718 31.3197Z",
    fill: "#FCA466",
    stroke: "#FB6B21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M75.2087 50.9217L70.2742 50.49L70.6855 45.7888C70.7184 45.4135 70.4518 45.0843 70.0894 45.0526L66.9993 44.7822C66.637 44.7505 66.3173 45.0285 66.2844 45.4037L65.8731 50.1049L60.9387 49.6732C60.5763 49.6415 60.2567 49.9194 60.2238 50.2947L59.9438 53.4949C59.911 53.8701 60.1776 54.1994 60.5399 54.2311L65.4744 54.6628L64.2774 68.3447C64.2445 68.72 64.5111 69.0492 64.8734 69.0809L67.9636 69.3513C68.3259 69.383 68.6456 69.105 68.6784 68.7298L69.8755 55.0478L74.8099 55.4795C75.1722 55.5112 75.4919 55.2333 75.5248 54.858L75.8047 51.6578C75.8376 51.2826 75.571 50.9534 75.2087 50.9217Z",
    fill: "#FB6B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3288 49.7008L71.7389 49.2118L72.2096 43.8318L67.8126 43.4471L67.3419 48.8271L61.752 48.338L61.3532 52.8959L66.9431 53.3849L65.6867 67.7457L70.0837 68.1304L71.3401 53.7696L76.9301 54.2587L77.3288 49.7008Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M54.156 71.8607C50.5661 62.2506 56.7098 51.6271 57.3243 40.6175C57.631 35.0957 56.5273 31.2519 55.3478 28.7907L53.65 28.6422C52.4046 28.529 51.3001 29.5242 51.1835 30.8566L46.8075 80.8748C46.6909 82.2071 47.6062 83.3749 48.852 83.4839L74.4687 85.725C74.4687 85.725 57.7459 81.4706 54.1523 71.8561L54.156 71.8607Z",
    fill: "#F96B21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_13636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.595,
    height: 53.0747,
    fill: "white",
    transform: "translate(28 25.5381) rotate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1912_13636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.1903,
    height: 62.8261,
    fill: "white",
    transform: "translate(51.0586 27.5957) rotate(5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibleNewIcon);
export default __webpack_public_path__ + "static/media/Bible_new_icon.b882738a8c2a241021c70de75049ff80.svg";
export { ForwardRef as ReactComponent };